<h2 mat-dialog-title>{{ 'dispute' | translate }}</h2>
<div mat-dialog-content>
    <table appFieldContainer>
        <!--
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'dispute_date' | translate }}</mat-label>
                    <input matInput [matDatepicker]="picker" [(ngModel)]="data.disputeDate" cdkFocusInitial>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
            </td>
        </tr>
        -->
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'reason' | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="data.reason">
                </mat-form-field>
            </td>
        </tr>
        <div>
            {{ 'notify_business_meaning' | translate }}
            <mat-checkbox [(ngModel)]="data.notifyBusiness">
                {{ 'notify_business' | translate }}
            </mat-checkbox>
        </div>
    </table>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="!isValidDispute()" [mat-dialog-close]="data">{{ 'ok' | translate }}</button>
    <button mat-button (click)="closeDialog()">{{ 'cancel' | translate }}</button>
</div>
